import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosInstance";
import * as S from "./style";
//Components
import { useAuth } from "context/AuthContext";
import Delete from "../../components/Delete";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import Details from "../../components/Modals/Lens/Details";
import Update from "../../components/Modals/Lens/Update";
import NoData from "../../components/NoData";
import PopMenu from "../../components/PopMenuTable";
import TitleFilter from "../../components/Title/TitleFilter";
import Toast from "../../components/Toast";
import TopActionBar from "../../components/TopActionBar";
//Hooks
import { useCheckbox } from "../../hooks/useCheckbox";
import useLoading from "../../hooks/useLoading";
import { useMultipleModal } from "../../hooks/useMultipleModal";
//utils
import { CurrencyFormat } from "utils/CurrencyFormat";
//Interface
import { ILens } from "Interfaces/ILens";
import { IPage } from "Interfaces/IPage";
import { IProductCart } from "Interfaces/IProductCart";
//Icons
import { List, PencilSimple, Tag, Trash, Package } from "@phosphor-icons/react";
import { FiMoreVertical } from "react-icons/fi";
export default function Lens() {
  const navigate = useNavigate();
  const UserAuthenticated = useAuth();
  const type_user = UserAuthenticated.user?.is_admin || UserAuthenticated.user?.is_manager;
  const [data, setData] = useState<ILens[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
    per_page: 0,
  });
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { selectedIds, toggleCheckbox, setSelectedIds, CleanSelectIds } =
    useCheckbox();
  const [selectAll, setSelectAll] = useState(false);
  const [toastData, setToastData] = useState({
    status: 200,
    message: "",
  });
  // Para um array de objetos
  const [tags, setTags] = useState<Array<{
    barcode: string;
    code: string;
    price: string;
  }>>([]);

  const [headerTable, setHeaderTable] = useState([
    { name: '#', filter: false },
    { name: 'ID', filter: false },
    { name: 'Nome', filter: false },
    { name: 'Tipo', filter: true, url: 'type_lens.type_lens', api: 'tipo', activeFilter: false },
    { name: 'Índice', filter: true, url: 'indices.index', api: 'indice', activeFilter: false },
    { name: 'Surfaçagem', filter: true, url: 'surfacings.surfacing', api: 'surfacing', activeFilter: false },
    { name: 'Antirreflexo', filter: true, url: 'treatment.treatment', api: 'tratamento', activeFilter: false },
    { name: 'Fotossen.', filter: true, url: 'sensitivity.sensitivity', api: 'fotossensibilidade', activeFilter: false },
    { name: 'Esferico', filter: false, url: 'spherical', api: 'esferico' },
    { name: 'Cilindro', filter: false, url: 'cylindrical', api: 'cilindro' },
    { name: 'Adição', filter: false, url: 'addition', api: 'adicao' },
    { name: 'Preço', filter: false },
    { name: 'Ações', filter: false },
  ]);

  const menuItemsPop = [
    { icon: <Package size={16} />, title: "Estoque", isActive: false, path: "stock" },
    { icon: <List size={16} />, title: "Detalhes", isActive: false, path: "details" },
    { icon: <PencilSimple size={16} />, title: "Editar", isActive: false, path: "update" },
    { icon: <Trash size={16} />, title: "Excluir", isActive: true, path: "delete" },
  ];

  const titleListPopMenu = [
    "Lente",
    "Altura",
    "Antirreflexo",
    "Diâmetro",
    "Fotossensibilidade",
    "Índice",
    "Laboratório",
    "Surfaçagem",
    "Tipo de Lente",
  ];

  const titlePopButtton = [
    "lens",
    "height",
    "anti-glare",
    "diameter",
    "sensitivity",
    "index",
    "laboratory",
    "surfacing",
    "type-lens",
  ];

  const [filters, setFilters] = useState<Record<string, string | number>>({});

  const [filterTableData, setFilterTableData] = useState([]);

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const extractFilter = (apidata: ILens[]) => {
    headerTable.forEach((header) => {
      if (header.filter && header.api && header.url) {
        let uniqueValues: any[] = [];

        if (header.url.includes('.')) {
          // Ex: 'category.name'
          const [parentProp, childProp] = header.url.split('.');

          uniqueValues = Array.from(
            new Set(
              apidata
                .map(item => item[parentProp as keyof ILens])
                .filter(obj => obj !== null && obj !== undefined)
                .map(obj => (obj as any)[childProp])
            )
          ).map(value => ({
            value,
          }));
        } else {
          // Ex: 'brand'
          uniqueValues = Array.from(
            new Set(
              apidata
                .map(item => (item as any)[header.url])
                .filter(value => value !== null && value !== undefined)
            )
          ).map(value => ({
            value,
          }));
        }

        setFilterTableData((prevData: any) => {
          const existingFilter = prevData.find((f: any) => f.key === header.api);

          if (existingFilter) {
            return prevData.map((f: any) =>
              f.key === header.api ? { ...f, data: uniqueValues } : f
            );
          } else {
            return [
              ...prevData,
              {
                key: header.api,
                title: header.name,
                data: uniqueValues,
              },
            ];
          }
        });
      }
    });
  };

  //Atualizar dados com registro atual de paginação
  const refreshFrames = () => {
    fetchData(page.current_page, page.per_page);
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/lens?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm.trim()) {
        url += `&search=${searchTerm}`;
      }

      // Adicionar filtros à URL
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          url += `&${key}=${value}`;
        }
      });

      const response = await axiosInstance.get(url);
      const apiData = response.data.data;

      extractFilter(apiData);

      setData(response.data.data);
      setCurrentPage(response.data);
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm, filters]);

  //Limpar os filtros
  const handleClearFilters = () => {
    setFilters({});
    fetchData();
  };

  const handleSelectAll = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const newSelectedIds = new Set(data.map((item) => item.id));
      setSelectedIds(newSelectedIds);

      // Adiciona todos os itens às tags se ainda não estiverem presentes
      setTags(prevTags => {
        // Criar um mapa dos códigos existentes para evitar duplicatas
        const existingCodes = new Set(prevTags.map(tag => tag.code));

        // Filtrar apenas os itens que ainda não existem nas tags
        const newItems = data.filter(item => !existingCodes.has(item.barcode))
          .map(item => ({
            barcode: item.barcode || '',
            code: item.name_lens || '',
            price: item.price || ''
          }));

        // Retorne a combinação do array anterior com os novos itens
        return [...prevTags, ...newItems];
      });

    } else {
      CleanSelectIds();
      setTags([]);
    }
  };

  const handleCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number,
    barcode: string,
    code: string,
    price: string,
  ) => {
    const isChecked = event.target.checked;
    toggleCheckbox(id);
    setTags(prevTags => {
      if (isChecked) {
        return [
          ...prevTags,
          {
            barcode,
            code,
            price
          }
        ];
      } else {
        // Remove
        return prevTags.filter(tag => tag.barcode !== barcode);
      }
    });

  };

  const handleDeleteResponse = (status: number) => {
    if (status === 200) {
      setSelectedIds(new Set());
      setSelectAll(false);
    }
  };

  const exportData = async () => {
    startLoading();
    try {
      if (type_user) {
        window.open('https://apioticamundial.clinicadeolhos.shop/lens-report', '_blank');
      } else {
        window.open('https://apioticamundial.clinicadeolhos.shop/lens-saller-report', '_blank');
      }
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  const handleMenuClick = (path: string, id: number) => {
    if (path === 'stock') {
      // navigate('/estoqueDeLente');
      navigate("/estoqueDeLente", { state: { id: id } })
    }
    toggleModalVisibility(path);
  };

  const getSelectedProducts = (): IProductCart[] => {
    return data.filter(item => selectedIds.includes(item.id)) // Converter id para string na comparação
      .map(item => ({
        id: item.id.toString(), // Converter number para string
        code: item.name_lens || item.barcode,
        type: 'lens',
        amount: 1,
        price: parseFloat(item.price), // Converter string para number
      }));
  };

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  return (
    <S.Container>
      <TitleFilter
        filterSearch={handleSearchChange}
        title="Registro de Lentes"
        subtitle="Gerencie as lentes do sistema"
        placeholderSearch="Nome da Lente"
        listPopMenu={titleListPopMenu}
        fetchData={fetchData}
        listPopButton={titlePopButtton}
        exportButton={exportData}

        filtersTitle={filterTableData}
        onApplyFilters={setFilters}
        onClearFilters={handleClearFilters}
        initialValues={filters}
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.ContaintableButton>
            <S.ContentButton>
              {selectedIds.length > 0 && (
                <TopActionBar
                  idSelecteds={selectedIds}
                  typeProduct="lens"
                  urlFilter={filters}
                  fetchData={fetchData}
                  nameDeleteAll='lens-delete-multiple'
                  handleDeleteResponse={handleDeleteResponse}
                  isTag={true}
                  itemsTag={tags}
                  isPromo={true}
                  isCart={true}
                  selectedProducts={getSelectedProducts()}
                />
              )}
            </S.ContentButton>
            <S.Table>
              <S.THead>
                <tr>
                  <th>
                    <S.CheckBox
                      type="checkbox"
                      id="deleteAll"
                      checked={selectAll}
                      onChange={(e) => handleSelectAll(e)}
                    />
                  </th>
                  {
                    headerTable.map((header, index) => (
                      <th key={index}>
                        {header.name}
                      </th>
                    ))
                  }
                </tr>
              </S.THead>

              <S.TBody>
                {data.length > 0 ? (
                  data.map((val, index) => (
                    <tr key={index}>
                      <td>
                        <S.CheckBox
                          onChange={(e) => handleCheckChange(
                            e,
                            val.id,
                            val.barcode,
                            val.name_lens,
                            val.price
                          )}
                          type="checkbox"
                          checked={selectedIds.includes(val.id)}
                        />
                      </td>
                      <td>{(page.current_page - 1) * page.per_page + index + 1}</td>
                      <td>{val?.id || '-'}</td>
                      {/* <td>
                        {
                          val.promotion_items.length > 0 ?
                            <S.Td>
                              {val.name_lens || "-"}
                              <S.TagPromo>
                                < Tag size={12} weight="fill" />
                                Promo
                              </S.TagPromo>
                            </S.Td>
                            :
                            <td>{val.name_lens || "-"}</td>
                        }
                      </td> */}
                      <S.Td>
                        {val.name_lens || "-"}
                        {
                          val.promotion_items.length > 0 &&
                          <S.TagPromo>
                            < Tag size={12} weight="fill" />
                            Promo
                          </S.TagPromo>
                        }
                        <S.Text>
                          {CurrencyFormat(parseFloat(val.price || "0"))}
                        </S.Text>
                      </S.Td>
                      <td>{val.type_lens?.type_lens || "-"}</td>
                      <td>{val.indices?.index || "-"}</td>
                      <td>{val.surfacings?.surfacing || "-"}</td>
                      <td>{val.treatment?.treatment || "-"}</td>
                      <td>{val.sensitivity?.sensitivity || "-"}</td>
                      <td>
                        {val.spherical_start || "-"}/
                        {val.spherical_end || "-"}
                      </td>
                      <td>
                        {val.cylindrical_start || '-'}/
                        {val.cylindrical_end || '-'}
                      </td>
                      <td>
                        {val.addition_start || '-'}/
                        {val.addition_end || '-'}
                      </td>
                      <td>
                        {CurrencyFormat(parseFloat(val.price || '0')) || '-'}
                      </td>

                      <S.TdPopMenu>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>
                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu
                              menuItems={menuItemsPop}
                              onClickTable={(e) => handleMenuClick(e, val.id)}
                            />
                          </div>
                        )}
                      </S.TdPopMenu>
                    </tr>
                  ))
                ) : (
                  <NoData />
                )}
              </S.TBody>
            </S.Table>
          </S.ContaintableButton>
        </S.Content>
      )}

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}
      {
        isOpenModal("details") &&
        <Details
          isOpenModalDetails={isOpenModal("details")}
          setModalClose={() => toggleModalVisibility("details")}
          selectedUrlId={openModalOptId}
        />
      }

      <Delete
        updateList={refreshFrames}
        endpoint="lens"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
      <Update
        isOpenModal={isOpenModal("update")}
        setModalClose={() => toggleModalVisibility("update")}
        selectedUrlId={openModalOptId}
        refreshFrames={refreshFrames}
        setToastOpen={() => toggleModalVisibility('open-toast')}
        setToastData={setToastData}
      />
      <Toast
        openToast={isOpenModal('open-toast')}
        closeToast={() => toggleModalVisibility('open-toast')}
        message={toastData.message}
        status={toastData.status}
      />
    </S.Container>
  );
}
